import { Link } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import useSeasonDetails from "../../hooks/useSeasonDetails";

function CurrentDonorHero({
    buttonText = "Jetzt mitmachen",
    buttonLink = "/mitmachen",
    secondaryButtonText,
    secondaryButtonLink,
    logoBasePath = "/spendenziel/",
}) {
    const { data } = useSeasonDetails();
    const list = data?.pages?.Spendenziel?.spendenempfaenger?.content || [];
    const current = list.filter((d) => d.show !== false)[0];

    return (
        <div>
            <div className="my-12"></div>
            <div className="bg-white rounded-2xl m-auto flex flex-col lg:flex-row p-8 text-blue-dark">
                <div className="w-full lg:w-1/3 flex items-center justify-center">
                    {current?.logo && (
                        <img
                            src={`${logoBasePath}${current.logo}`}
                            alt="spendenziel"
                            className="w-48 lg:w-full max-w-xs object-contain"
                        />
                    )}
                </div>
                <div className="w-full lg:w-2/3 lg:pl-8 mt-6 lg:mt-0 flex flex-col justify-between">
                    <div>
                        <div className="font-bold text-2xl lg:text-3xl text-golden mb-4">
                            {current ? `Spendenziel ${current.year}` : "Spendenziel"}
                        </div>
                        <p>
                            {current ? (
                                <>
                                    Mit unserer diesjährigen Aktion unterstützen wir Dresdner Lions und Leos den{" "}
                                    <b>{current.recipient}</b>. {current.description}
                                </>
                            ) : (
                                "Wird geladen..."
                            )}
                        </p>
                    </div>
                    <div className="mt-6 flex flex-col sm:flex-row gap-3">
                        <Link to={buttonLink}>
                            <div className="font-bold p-4 bg-golden text-white rounded-2xl shadow-md cursor-pointer flex flex-row items-center">
                                {buttonText} <MdOutlineKeyboardArrowRight size={30} />
                            </div>
                        </Link>
                        {secondaryButtonText && secondaryButtonLink && (
                            <Link to={secondaryButtonLink}>
                                <div className="font-bold p-4 text-golden rounded-2xl shadow-md cursor-pointer flex flex-row items-center">
                                    {secondaryButtonText} <MdOutlineKeyboardArrowRight size={30} />
                                </div>
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CurrentDonorHero;
